export default __webpack_public_path__ + "static/media/checkbox.148f30a1.svg";